export default __webpack_public_path__ + "../staticImages/flag-nur-bei-vinos.svg";